(function () {
    'use strict';

    function milestoneModalController($scope, $uibModalInstance, milestonesAndTemplates) {
        $scope.milestonesAndTemplates = milestonesAndTemplates;
        $scope.close = function () {
            var completedMilestoneNames = $scope.milestonesAndTemplates.filter(function(milestoneAndTemplate) {
                return milestoneAndTemplate.isMarkedComplete;
            }).map(function(milestoneAndTemplate) {
                return milestoneAndTemplate.milestoneName;
            });
            $uibModalInstance.close(completedMilestoneNames);
        };
        
        var updatePosition = function () {
            $scope.canGoForward = $scope.currentMilestoneIndex < $scope.milestonesAndTemplates.length - 1;
            $scope.canGoBackwards = $scope.currentMilestoneIndex > 0;
        }

        $scope.currentMilestoneIndex = 0;
        updatePosition();

        $scope.goForward = function() {
            $scope.currentMilestoneIndex += 1;
            updatePosition();
        }

        $scope.goBackwards = function() {
            $scope.currentMilestoneIndex -= 1;
            updatePosition();
        }
    }

    milestoneModalController.$inject = ['$scope', '$uibModalInstance', 'milestonesAndTemplates'];

    angular.module('ecap.dashboards').controller('milestoneModalController', milestoneModalController);
})();
